'use client';

import { Box, Button } from '@mui/material';

import { useState } from 'react';
import { usePathname } from 'next/navigation';
import { sendGTMEvent } from '@next/third-parties/google';
import { vendorHeightFooter, colorVariables, footerHeight } from '@/constants';
import { Vendor } from '@/lib/types/interfaces/Vendor';
import theme from '@/theme';
import Footer from '@/components/Footer';
import LeadFormDrawer from '@/components/LeadFormDrawer';

const FooterVendor = ({ service }: { service: Vendor }) => {
  const [isLeadDrawerOpened, setIsLeadDrawerOpened] = useState(false);
  const pathname = usePathname();

  const handleRequestQuoteClick = () => {
    setIsLeadDrawerOpened(true);
    sendGTMEvent({
      url: pathname,
      event: 'click_on_service_provider_request_quote',
      service_provider_name: service.business_name,
    });
  };

  return (
    <>
      <Footer
        sx={{
          [theme.breakpoints.down('lg')]: {
            marginBottom: vendorHeightFooter / 8,
            height: '100%',
          },
          height: footerHeight,
        }}
      />
      <Box
        bgcolor='white'
        display={{ xs: 'flex', lg: 'none' }}
        height={74}
        flexDirection='column'
        position='fixed'
        bottom='0'
        width='100%'
        paddingX={3}
        sx={{
          borderTop: `1px solid ${colorVariables.separatorColor}`,
        }}
      >
        <Button
          variant='contained'
          color='success'
          sx={{
            marginTop: 2,
            color: 'white',
            minHeight: '42px',
            width: '100%',
          }}
          onClick={handleRequestQuoteClick}
        >
          Request Quote
        </Button>
      </Box>
      <LeadFormDrawer
        open={isLeadDrawerOpened}
        onClose={() => setIsLeadDrawerOpened(false)}
        service={service}
      />
    </>
  );
};

export default FooterVendor;
